import { makeStyles } from 'tss-react/mui';

import { Breakpoint } from '@constants/common/ui.constants';

const useStyles = makeStyles()((theme) => ({
  container: {
    maxWidth: '1344px',
    width: 'calc(100% - 48px)',
    margin: '0 auto',

    [theme.breakpoints.down(Breakpoint.Lg)]: {
      width: 'calc(100% - 30px)',
    },

    [theme.breakpoints.down(Breakpoint.Sm)]: {
      minWidth: '280px',
      padding: '0 16px',
      width: '100%',
    },
  },
}));

export default useStyles;
